<template>
  <div class="result-page">
    <Card class="result-card">
      <template #content>
        <div class="result-content">
          <i class="pi pi-times-circle cancel-icon" />
          <h1>Pago cancelado</h1>
          <p>El proceso de pago fue cancelado. Puedes intentarlo de nuevo cuando quieras.</p>
          <Button label="Ver Planes" icon="pi pi-list" @click="router.push('/plans')" />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import Card from 'primevue/card';
import Button from 'primevue/button';
const router = useRouter();
</script>

<style scoped>
.result-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #f8fafc; }
.result-card { max-width: 400px; width: 100%; }
.result-content { text-align: center; padding: 1rem; }
.cancel-icon { font-size: 4rem; color: #ef4444; margin-bottom: 1rem; }
h1 { color: #1e293b; margin-bottom: 0.5rem; }
p { color: #6b7280; margin-bottom: 1.5rem; }
</style>
